import { onAuthStateChanged, User } from 'firebase/auth';
import { auth } from '@/config/firebase';
import { handleAuthError } from '@/lib/utils/errors/handlers';

export function onAuthStateChange(
  callback: (user: User | null) => void
): () => void {
  try {
    return onAuthStateChanged(auth, callback);
  } catch (error) {
    throw handleAuthError(error);
  }
}

export function getCurrentUser(): User | null {
  return auth.currentUser;
}

export function isAuthenticated(): boolean {
  return auth.currentUser !== null;
}

export function getUserId(): string | null {
  return auth.currentUser?.uid || null;
}
